









































































import TextbookIssuePage from './components/TextbookIssue/TextbookIssuePage.vue'
import EditMediaItemOccurence from './components/TextbookIssue/EditMediaItemOccurence.vue'
import PagePagination from '@/components/custom/PagePagination.vue'
import {
  defineComponent,
  ref,
  onBeforeMount,
  computed,
  inject,
  watch,
} from '@vue/composition-api'
import {
  getTextbookIssuePage,
  reorderMediaItemOccurences,
  deleteMediaItemOccurences,
  changePage,
  textbookIssuePageLink,
} from '@/shared/api'
import { MediaItemOccurence } from '@/shared/types'
import { sortByOrder } from '@/shared/utils'
import { alertSymbol } from '@/shared/state-management/symbols'
import { useStore as useTextbookStore } from '@/shared/state-management/textbookStore'

export default defineComponent({
  name: 'TextbookIssueDetailPage',
  components: {
    TextbookIssuePage,
    EditMediaItemOccurence,
    PagePagination,
  },
  setup(props, { root }) {
    const $alert = inject(alertSymbol) as Function
    const { getters } = useTextbookStore()
    const { activeTextbookIssue, activeTextbook } = getters

    const textbookIssueId = computed(() => root.$route.params.textbookIssueId)
    const page = computed(() => parseInt(root.$route.params.page))
    const loading = ref(false)
    const textbookIssuePageMediaElements = ref([] as Array<MediaItemOccurence>)
    const selectedMediaItems = ref([])
    const mediaItemOccurenceUnderEdit = ref(null)
    const editDialogOpen = ref(false)

    const orderedMediaElements = computed(() =>
      sortByOrder(textbookIssuePageMediaElements.value)
    )

    const changeCurrentPage = (newPage: number) => {
      root.$router.push({
        name: root.$route.name,
        params: { ...root.$route.params, page: newPage.toString() },
      })
    }

    const reorderMediaElements = async (
      newArray: Array<MediaItemOccurence>
    ) => {
      if (loading.value) {
        return
      }

      loading.value = true
      const oldArray = [...orderedMediaElements.value]
      try {
        const order = newArray.map((el: MediaItemOccurence, index: number) => ({
          id: el.id,
          order: '' + index,
        }))

        textbookIssuePageMediaElements.value = newArray
        const reorderedMediaElements = await reorderMediaItemOccurences(
          textbookIssueId.value,
          page.value,
          order
        )
        textbookIssuePageMediaElements.value = reorderedMediaElements
        loading.value = false
      } catch (e) {
        textbookIssuePageMediaElements.value = oldArray
        loading.value = false
        throw e
      }
      return true
    }

    const editMediaItemOccurence = (item: MediaItemOccurence) => {
      editDialogOpen.value = true
      mediaItemOccurenceUnderEdit.value = item
    }

    const updateSelected = () => {
      const mediaIds = textbookIssuePageMediaElements.value.map(
        (el: MediaItemOccurence) => el.id
      )
      for (let i = selectedMediaItems.value.length - 1; i >= 0; --i) {
        if (!mediaIds.includes(selectedMediaItems.value[i])) {
          selectedMediaItems.value.splice(i, 1)
        }
      }
    }

    const refreshMediaItemOccurences = async () => {
      loading.value = true
      textbookIssuePageMediaElements.value = await getTextbookIssuePage(
        textbookIssueId.value,
        page.value
      )
      updateSelected()
      loading.value = false
    }

    const mediaItemOccurenceEdited = () => {
      $alert({
        type: 'success',
        text: root.$t('mediaItemOccurence.editedSuccess'),
      })
      editDialogOpen.value = false
      refreshMediaItemOccurences()
    }

    const deleteSelected = async () => {
      const ids = selectedMediaItems.value.map(
        (occurence: MediaItemOccurence) => occurence.id
      )
      await $alert({
        text: root.$t('textbookIssuePage.confirmDeleteSelected'),
        type: 'confirm',
      })
      try {
        loading.value = true
        const deletedIds = await deleteMediaItemOccurences(
          textbookIssueId.value,
          ids
        )
        await refreshMediaItemOccurences()

        $alert({
          text: root.$t('textbookIssuePage.deleteSelectedSuccess', {
            number: deletedIds.ids.length,
          }),
          type: 'success',
        })
        loading.value = false
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    const deleteOccurence = async (occurence: MediaItemOccurence) => {
      await $alert({
        text: root.$t('textbookIssuePage.confirmDelete', {
          name: occurence.filename,
          page: page.value,
        }),
        type: 'confirm',
      })

      try {
        loading.value = true
        const deletedIds = await deleteMediaItemOccurences(
          textbookIssueId.value,
          [occurence.id]
        )
        await refreshMediaItemOccurences()

        $alert({
          text: root.$t('textbookIssuePage.deleteSelectedSuccess', {
            number: deletedIds.ids.length,
          }),
          type: 'success',
        })
        loading.value = false
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    const onChangePage = async (payload: { ids: string[]; page: number }) => {
      try {
        const ids = await changePage(
          textbookIssueId.value,
          payload.ids,
          payload.page
        )
        loading.value = true
        $alert({
          text: root.$t('textbookIssuePage.changePageSuccess', {
            number: ids.length,
            page: payload.page,
          }),
          type: 'success',
        })
      } catch (e) {
        loading.value = false
        throw e
      }
      refreshMediaItemOccurences()
    }

    onBeforeMount(refreshMediaItemOccurences)
    watch(page, refreshMediaItemOccurences)

    return {
      orderedMediaElements,
      textbookIssueId,
      activeTextbookIssue,
      activeTextbook,
      editDialogOpen,
      editMediaItemOccurence,
      page,
      loading,
      reorderMediaElements,
      deleteSelected,
      selectedMediaItems,
      deleteOccurence,
      mediaItemOccurenceUnderEdit,
      mediaItemOccurenceEdited,
      onChangePage,
      changeCurrentPage,
      textbookIssuePageLink,
    }
  },
})
